export var palette = {
  background: {
    default: '#FFFFFF',
    paper: '#fff'
  },
  common: {
    black: '#000',
    white: '#fff'
  },
  grey: {
    '50': '#fafafa',
    '100': '#f5f5f5',
    '200': '#eeeeee',
    '300': '#e0e0e0',
    '400': '#BDBDBD',
    '500': '#9E9E9E',
    '600': '#757575',
    '700': '#616161',
    '800': '#424242',
    '900': '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
  bottomStepper: {
    height: '80px'
  },
  loginComponent: {
    width: '380px'
  },
  authenticationComponent: {
    width: '814px',
    background: '#FFFFFF'
  },
  leftColumnComponent: {
    width: '326px'
  },
  text: {
    primary: 'rgba(0, 0, 0, 0.87)',
    secondary: 'rgba(0, 0, 0, 0.6)',
    disabled: 'rgba(0, 0, 0, 0.38)'
  },
  error: {
    main: '#dc2626',
    dark: '#5f2120',
    light: '#FDEDED',
    contrastText: '#fff'
  },
  warning: {
    main: '#ed6c02',
    dark: '#663c00',
    light: 'rgb(255, 244, 229)',
    contrastText: 'rgb(237, 108, 2)'
  },
  info: {
    main: '#0288d1',
    dark: '#014361',
    light: '#e5f6fd',
    contrastText: '#fff'
  },
  success: {
    main: '#2e7d32',
    dark: '#1E4620',
    light: '#edf7ed',
    contrastText: '#fff'
  },
  divider: 'rgba(0, 0, 0, 0.12)'
};
export var baseTheme = {
  palette: palette,
  background: {
    default: '#FFFFFF',
    secondary: '#e9f2f2'
  },
  button: {
    borderRadius: 10
  },
  spaces: {
    bigger: 12,
    large: 6,
    big: 4,
    main: 2,
    small: 1
  },
  sizes: {
    drawer: 354
  },
  icons: {
    status: {
      info: 'info',
      success: 'success',
      warning: 'warning',
      error: 'error'
    }
  }
};
//# sourceMappingURL=base.js.map